/** @jsx jsx */

import { Fragment as _, useEffect, memo } from 'react';
import { jsx } from '@emotion/core';
import EditableText from 'components/lib/EditableText';
import Flipcards_v2 from './Flipcards_v2';
import Flipcard_v2 from './Flipcard_v2';
import renderBlock from 'services/apiHelpers/renderBlock';
import { Row, Column, Button, Box } from '@chameleoncreator/creator-ui';
import Image from 'components/lib/Image';
import Video from 'components/lib/Video';
import Audio from 'components/lib/Audio';
import SVG from 'components/lib/SVG';
import Media from 'components/lib/Media';
import { interactionContext } from './interactionContext';
import Container from 'components/Layouts/ContainerLogical';
import getBlockById from 'services/apiHelpers/getBlockById';
import continueBtn from '../ContinueBtn/continueBtn_v2';
import { Block } from '@chameleoncreator/creator-app';
import IELayout from 'components/Layouts/IELayout';
import shouldUpdate from 'services/shouldUpdate';
import { useSelector } from 'react-redux';
import { State } from 'store/store';
import setBlockProps from 'services/apiHelpers/setBlockProps';

import imagePlaceholder from 'assets/Square.png';
//Flip2.png';

const SingleColumnLayout = Row.bind({}) as any;
SingleColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'column',
};

const TwoColumnLayout = Row.bind({}) as any;
TwoColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'row',
};

const Components = {
  Row,
  Column,
  Text: ({ children, ...props }) => (
    <EditableText {...{ ...props, className: 'flipcard-text' }} />
  ),
  Flipcards: Flipcards_v2,
  Flipcard: Flipcard_v2,
  FlipcardSide: ({ children }) => children,
  Front: ({ children }) => children,
  Back: ({ children }) => children,
  Image: ({ children, ...props }) => {
    // let src = props.src || Flip2;
    // console.log(src);

    return (
      <Image
        {...{
          ...props,
          placeholder: imagePlaceholder,
          editWrapperType: 1,
        }}
      />
    );
  },
  Video,
  Audio,
  // these can return null
  Transcript: () => null,
  EditableButton: () => null,
  //
  SVG: ({ children, ...props }) => (
    <SVG {...{ ...props, editWrapperType: 1 }} />
  ),
  Embed: () => null,
  Media,
  TwoColumnLayout: TwoColumnLayout,
  SingleColumnLayout: SingleColumnLayout,
  ContinueButton: continueBtn,
  PDF: () => null,
  OpenPDF: () => null,
  ...IELayout(interactionContext),
};

const FlipCardDisplay = memo((props: any) => {
  const interactionBlock = getBlockById(props.blockId);
  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <interactionContext.Provider
        value={{ ...interactionBlock, updateItemsSeen: null }}
      >
        {(interactionBlock.children as Block[]).map(child => {
          return renderBlock(child, Components);
        })}
      </interactionContext.Provider>
    </Container>
  );
}, shouldUpdate as any);

export default FlipCardDisplay;
